(function () {
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  onReady(() => {
    document.querySelectorAll('[data-dg-reveal]').forEach((el) => {
      requestAnimationFrame(() => el.classList.add('is-visible'));
    });

    document.querySelectorAll('[data-dg-size-guide-open]').forEach((openBtn) => {
      const modal = openBtn.closest('.dg-product-extras')?.querySelector('[data-dg-size-guide-modal]');
      if (!modal) return;
      const closeNodes = modal.querySelectorAll('[data-dg-size-guide-close]');
      const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      };
      openBtn.addEventListener('click', () => {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      });
      closeNodes.forEach((node) => node.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    });

    document.querySelectorAll('[data-dg-whatsapp-product]').forEach((wrapper) => {
      const link = wrapper.querySelector('[data-dg-whatsapp-order]');
      const variantInput = wrapper.closest('form')?.querySelector('input[name="id"]');
      const variantsScript = wrapper.querySelector('[data-dg-product-variants]');
      if (!link || !variantInput || !variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        return;
      }

      const updateLink = () => {
        const selectedVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
        if (!selectedVariant) return;
        const price = (selectedVariant.price / 100).toFixed(2);
        const message = [
          'Hi Dear Giselle, I would like to order:',
          `Product: ${link.dataset.productTitle}`,
          `Variant: ${selectedVariant.title}`,
          `Price: HK$${price}`,
          `URL: ${link.dataset.productUrl}`
        ].join('\n');
        link.href = `${wrapper.dataset.baseUrl}?text=${encodeURIComponent(message)}`;
      };

      updateLink();
      document.addEventListener('change', updateLink);
    });

    document.querySelectorAll('[data-dg-quick-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;
        if (!variantId) return;
        const original = button.textContent;
        button.classList.add('is-loading');
        button.textContent = 'Adding...';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (!response.ok) throw new Error('Quick add failed');
          button.textContent = 'Added ✓';
          setTimeout(() => {
            button.textContent = original;
            button.classList.remove('is-loading');
          }, 1100);
        } catch (error) {
          button.textContent = 'View product';
          button.classList.remove('is-loading');
        }
      });
    });

    document.querySelectorAll('[data-dg-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-dg-carousel-track]');
      const prev = carousel.querySelector('[data-dg-carousel-prev]');
      const next = carousel.querySelector('[data-dg-carousel-next]');
      if (!track || !prev || !next) return;

      const slide = () => Math.max(track.clientWidth * 0.85, 220);
      prev.addEventListener('click', () => track.scrollBy({ left: -slide(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: slide(), behavior: 'smooth' }));
    });

    document.querySelectorAll('variant-picker fieldset.variant-option--buttons').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend')?.textContent?.toLowerCase() || '';
      if (legend.includes('size')) {
        fieldset.classList.add('dg-size-option');
      }
    });
  });
})();
